import type { RevealedContactDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import type { ContactsResponseDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

import { replaceWidgetJsonBlocks } from "./replaceWidgetJsonBlocks";

const WIDGET_JSON_INDENT = 2;

export const augmentContactWidgetWithContactsSearchData = (
    message: string,
    contactsResponse: ContactsResponseDto,
): string => {
    return replaceWidgetJsonBlocks(
        message,
        (parsed) => {
            if (parsed.type !== "widget_contacts" || !Array.isArray(parsed.data)) {
                return null;
            }

            const contactsSearchData: ContactsResponseDto = {
                rows: [...contactsResponse.rows],
                totalCount: contactsResponse.totalCount,
            };

            const mergedRevealed: Record<string, RevealedContactDto> = {
                ...(parsed.revealedContacts as Record<string, RevealedContactDto> | undefined),
            };
            for (const row of contactsResponse.rows) {
                if (row.isRevealed === true && "revealedInfo" in row) {
                    mergedRevealed[row.id] = row.revealedInfo;
                }
            }

            return {
                type: "widget_contacts",
                data: parsed.data,
                ...(Object.keys(mergedRevealed).length > 0 ? { revealedContacts: mergedRevealed } : {}),
                contactsSearchData,
            };
        },
        WIDGET_JSON_INDENT,
    );
};
